import { render, staticRenderFns } from "./PopupConfirmation.vue?vue&type=template&id=ae72a8de"
import script from "./PopupConfirmation.vue?vue&type=script&lang=ts"
export * from "./PopupConfirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports